import { render, staticRenderFns } from "./CustomizedService.vue?vue&type=template&id=5160eb19&scoped=true&"
import script from "./CustomizedService.vue?vue&type=script&lang=js&"
export * from "./CustomizedService.vue?vue&type=script&lang=js&"
import style0 from "./CustomizedService.vue?vue&type=style&index=0&id=5160eb19&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5160eb19",
  null
  
)

export default component.exports